import React, { useState, useEffect } from "react";
// Reuse existing styles for visual consistency
import "../ToggleSwitch/ToggleSwitch.scss";

// A self-contained toggle switch that does not depend on any global context.
// Supports both controlled (via `checked`) and uncontrolled (via `initialChecked`) usage.
export default function SimpleToggleSwitch({
  settingsToggle,
  settingsToggleTwoSidesSame,
  onToggle,
  checked,
  initialChecked = false,
  startText,
  endText,
}) {
  const [internalChecked, setInternalChecked] = useState(initialChecked);

  // Sync internal state if component is used in a controlled way
  useEffect(() => {
    if (typeof checked === "boolean") {
      setInternalChecked(checked);
    }
  }, [checked]);

  const handleToggle = () => {
    if (typeof checked !== "boolean") {
      setInternalChecked((prev) => !prev);
    }
    onToggle && onToggle();
  };

  return (
    <label className="simple-toggle-switch">
      {startText && startText}
      <div
        className={
          " toggleSwitch_check-box " +
          (settingsToggle ? " settingsToggle " : "") +
          (settingsToggleTwoSidesSame ? " settingsToggleTwoSidesSame " : "")
        }
      >
        <input
          className="toggleSwitch_input"
          type="checkbox"
          checked={internalChecked}
          onChange={handleToggle}
        />
      </div>
      {endText && endText}
    </label>
  );
}
